import {SecurityIssue} from "./security-issue";
import {Utils} from '../../../shared/utils/utils';

export class SecurityIssueMapper {

  private static statusMap: any = {
    'added_file': 'Added',
    'modified_file': 'Modified',
    'missing_file': 'Missing'
  };

  public static map(data: any, type: string, diffType: string): SecurityIssue {
    const securityIssue: SecurityIssue = new SecurityIssue();

    securityIssue.id = Utils.generateUid();
    securityIssue.type = type;
    securityIssue.diffType = diffType;
    securityIssue.fileName = data.file_name;
    securityIssue.file_path = data.file_path;
    securityIssue.status = SecurityIssueMapper.statusMap[data.status] || Utils.uppercaseFirst(data.status.toString().split('_file').join(''));
    securityIssue.version = data.options ? data.options.version : '';
    securityIssue.slug = data.options ? data.options.slug : '';
    securityIssue.selected = false;

    return securityIssue;
  }

}
